import DriverServicesApi from "../../services/api/DriverServices";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import ActionTypes from "./ActionTypes";

function handleError(err) {
  console.log("error in driver services actions:", err);
}
export const setDriverServices = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_SERVICES,
    payload,
  };
};

export const setExclusiveDriverServices = (payload) => {
  return {
    type: ActionTypes.SET_EXCLUSIVE_DRIVER_SERVICES,
    payload,
  };
};

export const getDriverServiceById = (service_id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverServicesApi.getDriverServices();
    dispatch(setLoader(false));
    let driver_services = response.driver_services;
    return driver_services.find((el) => el.id == service_id);
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverServiceByIds = (service_ids) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverServicesApi.getDriverServices();
    dispatch(setLoader(false));
    let driver_services = response.driver_services;
    return service_ids.map((id) => driver_services.find((el) => el.id == id));
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverServices = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverServicesApi.getDriverServices();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setDriverServices(response));
      return response;
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getExclusiveDriverServices = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverServicesApi.exclusiveDriverService();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setExclusiveDriverServices(response?.driver_services ?? []));
      return response;
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
